<template>
  <v-dialog
    v-model="show"
    persistent
    width="1200px"
    scrollable
    :fullscreen="$vuetify.breakpoint.mobile"
  >
    <template
      v-for="(_, scopedSlotName) in $scopedSlots"
      #[scopedSlotName]="slotData"
    >
      <slot :name="scopedSlotName" v-bind="slotData" />
    </template>
    <template v-for="(_, slotName) in $slots" #[slotName]>
      <slot :name="slotName" />
    </template>
    <v-card :loading="isLoading">
      <v-card-title>
        <div v-if="mode === 'add'">Add Lesson Category</div>
        <div v-else-if="mode === 'edit'">Edit Lesson Category</div>
        <div v-else>View Lesson Category</div>
        <v-spacer></v-spacer>
        <v-btn icon @click="show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-form ref="form" :disabled="isReadonly || isLoading">
          <div class="label mb-2">Name</div>
          <v-text-field
            v-model="form.name"
            :rules="[validationRules.required]"
            placeholder="Category name"
            solo
            flat
            outlined
            dense
          />
          <div class="label mb-2">Name (Chinese)</div>
          <v-text-field
            v-model="form.name_cn"
            placeholder="Category name (Chinese)"
            solo
            flat
            outlined
            dense
          />
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-container fluid>
          <v-row justify="end">
            <v-col md="3" cols="12">
              <v-btn block depressed outlined @click="show = false"
                >Cancel</v-btn
              >
            </v-col>
            <v-col md="3" cols="12">
              <v-btn
                block
                depressed
                color="primary"
                :disabled="isReadonly || isLoading"
                @click="submit"
              >
                Save Changes
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'LessonCategoryFormDialog',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    category: {
      type: Object,
      default: null,
      required: false,
    },
    mode: {
      type: String,
      required: true,
      validator: () => ['add', 'edit', 'view'],
    },
  },
  data() {
    return {
      form: {
        name: null,
        name_cn: null,
      },
    }
  },
  computed: {
    ...mapGetters({
      isLoading: 'lessonCategory/isDetailLoading',
    }),
    show: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    isReadonly() {
      return this.mode === 'view'
    },
  },
  watch: {
    $props: {
      immediate: true,
      handler() {
        this.validateProps()
      },
    },
  },
  created() {
    this.init()
  },
  methods: {
    ...mapActions({
      createCategory: 'lessonCategory/create',
      updateCategory: 'lessonCategory/update',
    }),
    validateProps() {
      if ((this.mode === 'edit' || this.mode === 'view') && !this.category) {
        console.error(
          `category props must be provided for 'edit' and 'view' mode`
        )
      }
    },
    init() {
      if (this.mode != 'add' && this.category != null) {
        _.merge(this.form, this.category)
      }
    },
    resetForm() {
      this.form = {
        name: null,
        name_cn: null,
      }
    },
    async submit() {
      if (this.$refs.form.validate()) {
        if (this.mode === 'add') {
          await this.createCategory(this.form)
        } else if (this.mode === 'edit') {
          await this.updateCategory(this.form)
        }
        this.$emit('submit', this.form)
        this.resetForm()
      }
    },
  },
}
</script>
